import React, { useEffect, useState } from "react";
import "./GallerySlideshow.css";

function GallerySlideshow({
  photos = [],
  intervalSeconds = 5,
  textColor = "#5c5470",
  className = "",
}) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!photos || photos.length < 2) return undefined;

    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % photos.length);
    }, Math.max(intervalSeconds, 2) * 1000);

    return () => clearInterval(timer);
  }, [photos, intervalSeconds]);

  if (!photos || photos.length === 0) return null;

  if (photos.length === 1) {
    return (
      <div className={`gallery-slideshow ${className}`}>
        <img src={photos[0]} alt="Memorial gallery" className="slideshow-image static" />
      </div>
    );
  }

  return (
    <div className={`gallery-slideshow ${className}`} style={{ borderColor: textColor }}>
      {photos.map((photo, i) => (
        <div
          key={`${photo}-${i}`}
          className={`slideshow-slide ${i === index ? "active" : ""}`}
          aria-hidden={i !== index}
        >
          <img
            src={photo}
            alt={`Memorial slide ${i + 1}`}
            className={`slideshow-image kenburns-${i % 4}`}
          />
        </div>
      ))}
      <div className="slideshow-dots">
        {photos.map((_, i) => (
          <button
            key={i}
            type="button"
            className={`slideshow-dot ${i === index ? "active" : ""}`}
            style={{ backgroundColor: i === index ? textColor : "transparent", borderColor: textColor }}
            onClick={() => setIndex(i)}
            aria-label={`Go to slide ${i + 1}`}
          />
        ))}
      </div>
    </div>
  );
}

export default GallerySlideshow;
